import { render } from "./PasswordResetEmailComponent.vue?vue&type=template&id=20161f56&scoped=true"
import script from "./PasswordResetEmailComponent.vue?vue&type=script&lang=js"
export * from "./PasswordResetEmailComponent.vue?vue&type=script&lang=js"

import "./PasswordResetEmailComponent.vue?vue&type=style&index=0&id=20161f56&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20161f56"]])

export default __exports__